export default "__VITE_PUBLIC_ASSET__6b1cc58f__"